import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LDProvider } from "launchdarkly-react-client-sdk";
import App from "./App.tsx";

const queryClient = new QueryClient();

const ldContext = {
  kind: "user" as const,
  key: "anonymous",
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <LDProvider
    clientSideID={import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID}
    context={ldContext}
    reactOptions={{ useCamelCaseFlagKeys: false }}
  >
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </LDProvider>,
);
